import { Config } from '../objects/config';
import { SET_CONFIG, HeaderActionTypes } from './actionTypes';

export const setConfig = (config: Config): HeaderActionTypes => ({
    type: SET_CONFIG,
    payload: config
});